import { type FC } from "react";

import { useLocalStorage } from "../../camkit/common/hooks/useLocalStorage";
import { AlertWithExpiration } from "../../shared/components/AlertWithExpiration";

import { marginBottomCSS } from "./TopLevelAlert.styles";
import { TopLevelAlertDescription, TopLevelAlertTitle } from "./messages.generated";

// TODO: Replace this with sds notification center component https://snap-design-system.gae.sc-corp.net/?path=/story/communication-notificationcenter--normal

// Update this value to control when the alert should be hidden on the Lens Folder page.
const END_DATE = "08/30/2024";
// Optional start date that can be set to a future date, defaults to: new Date()
// const START_DATE = "07/26/2024"

// Use this component for updating and displaying notifications on the Lens Folder page.
// Using message.json, update the values for TopLevelAlertTitle and TopLevelAlertDescription to control the message being displayed
export const TopLevelAlert: FC = () => {
    const [hideAlert, setHideAlert] = useLocalStorage("sc-top-level-alert", { hide: false });

    if (hideAlert.hide) {
        return null;
    }

    return (
        <AlertWithExpiration
            endDate={END_DATE}
            onClose={() => {
                setHideAlert({ hide: true });
            }}
            status="info"
            title={<TopLevelAlertTitle />}
            description={<TopLevelAlertDescription link={<a href="mailto:support@snap.com">support@snap.com</a>} />}
            closable
            className={marginBottomCSS}
        />
    );
};
